'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var Layout_components_UserMenu = require('./UserMenu.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var faBars = require('@fortawesome/pro-solid-svg-icons/faBars');
var hooks_useMediaQuery = require('../../hooks/useMediaQuery.js');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@fortawesome/pro-solid-svg-icons/faComments');
require('@fortawesome/pro-solid-svg-icons/faBook');
require('@fortawesome/pro-solid-svg-icons/faSignOutAlt');
require('@fortawesome/pro-solid-svg-icons/faUser');
require('@fortawesome/pro-solid-svg-icons/faCaretDown');
require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
require('@medipass/utils/intercom');
require('@medipass/web-sdk');
require('../../state.js');
require('constate');
require('../../contexts/DataTableContext.js');
require('@babel/runtime/helpers/defineProperty');
require('query-string');
require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject, _templateObject2;
var ContentHeader = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  font-weight: 400;\n  min-height: 60px;\n  padding: 0 1rem;\n  background-color: white;\n  z-index: 10;\n  position: relative;\n  color: ", ";\n"])), bumbag.palette('white900'), bumbag.palette('tertiary'));
var AbsoluteUserMenu = bumbag.styled(Layout_components_UserMenu["default"])(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  @media screen and (max-width: ", "px) {\n    display: none;\n  }\n"])), bumbag.theme('breakpoints.tablet'));

function Header(props) {
  var hasLegacySidebar = props.hasLegacySidebar,
      sidebar = props.sidebar,
      headerAddonComponent = props.headerAddonComponent,
      _isFluid = props.isFluid,
      userMenuProps = props.userMenuProps,
      minWidthBreakpoint = props.minWidthBreakpoint,
      title = props.title,
      titleAddonComponent = props.titleAddonComponent,
      shouldHideMobileMenu = props.shouldHideMobileMenu;
  var isFluid = _isFluid && !minWidthBreakpoint;
  var page = bumbag.usePage();
  var isMobile = hooks_useMediaQuery.useMediaQuery('(max-width: 1024px)');
  return /*#__PURE__*/React__default["default"].createElement(ContentHeader, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Container, {
    breakpoint: minWidthBreakpoint,
    isFluid: isFluid,
    display: "flex",
    paddingLeft: isFluid ? 'major-2' : undefined,
    paddingRight: isFluid ? 'major-2' : undefined,
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    display: "flex",
    alignItems: "center"
  }, hasLegacySidebar && page && page.isCollapsed && /*#__PURE__*/React__default["default"].createElement(bumbag.PageWithSidebar.Disclosure, null, function (props) {
    return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, _extends__default["default"]({
      use: "button",
      color: "text",
      variant: "ghost",
      marginRight: "major-2"
    }, props), /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faBars.faBars,
      className: "text-lg"
    }));
  }), sidebar && isMobile && !shouldHideMobileMenu && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, _extends__default["default"]({
    use: "button",
    color: "text",
    variant: "ghost",
    marginRight: "major-2"
  }, props), /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faBars.faBars,
    className: "text-lg",
    onClick: sidebar.open
  })), /*#__PURE__*/React__default["default"].createElement("h1", {
    className: "text-xl font-semibold leading-tight sm:text-xl md:text-2xl lg:text-3xl"
  }, title), titleAddonComponent), headerAddonComponent || /*#__PURE__*/React__default["default"].createElement(AbsoluteUserMenu, _extends__default["default"]({
    isHorizontal: true
  }, userMenuProps))));
}

Header.defaultProps = {
  hasLegacySidebar: false,
  headerAddonComponent: null,
  isFluid: true,
  minWidthBreakpoint: undefined,
  titleAddonComponent: /*#__PURE__*/React__default["default"].createElement("div", null),
  title: undefined,
  username: undefined
};

exports["default"] = Header;
